export default [
  {
    text: 'Barview Values',
    description: 'View values specified in BarView. Nothing is displayed if values are missing in BarView.',
    value: 'barview-values'
  },
  {
    text: 'Item Group Queue',
    description: 'Count items per item group.',
    value: 'itemgroup-queue'
  },
  {
    text: 'Queue Groups',
    description: 'Count items per queue group.',
    value: 'queue-group-queue'
  },
  {
    text: 'Order Queue Groups',
    description: 'Count orders per queue group.',
    value: 'order-queue-group-queue'
  }
];
